import type { ReactNode } from "react";
import { OrganizationAvatar } from "./console-identity";

/** Navigation and tenant identity only; scope is expressed by sidebar colors. */
export function ConsoleHeader({
  organization,
  title,
  imageUrl,
  children,
}: {
  organization?: string;
  title: string;
  imageUrl?: string;
  children?: ReactNode;
}) {
  return (
    <>
      <span className="mcc-header-page">{title}</span>
      <div className="mcc-header-actions">
        {organization && (
          <div className="mcc-header-context" aria-label="고객사 정보">
            <OrganizationAvatar name={organization} imageUrl={imageUrl} rail />
            <strong title={organization}>{organization}</strong>
          </div>
        )}
        {children}
      </div>
    </>
  );
}
